import { Colors } from '@zapier/design-system';
import { css } from '@emotion/core';

export const fontFamilyMonospace = [
  'ui-monospace',
  "'JetBrains Mono'",
  "'Cascadia Code'",
  "'SFMono-Regular'",
  'Menlo',
  'Monaco',
  'Consolas',
  "'Liberation Mono'",
  "'Courier New'",
  'monospace',
].join(', ');

const Styles = {
  root: css`
    display: flex;
    flex: 1;
    height: 100%;
    max-height: calc(100vh - 69px);

    .editor-body__editor .flowform .formatic .fm-field {
      input {
        &:read-only {
          background-color: ${Colors.GrayWarm2};
          cursor: not-allowed;
        }
      }

      .fm-help code {
        white-space: nowrap;
      }
    }

    .navbar__link {
      padding: 12px 1px 12px;
      display: flex;

      &:focus {
        outline: none;
      }
    }

    .input-section {
      margin-bottom: 28px;
    }

    .input-description {
      margin-bottom: 12px;
    }

    .input-title {
      font-size: 14px;
      font-weight: 600;
      margin-bottom: 8px;
      &::after {
        content: '(optional)';
        color: ${Colors.GrayWarm7};
        font-size: 11px;
        margin: 0 6px;
      }
      &--required {
        &::after {
          content: '(required)';
          color: ${Colors.Red4};
        }
      }
      &--title-only {
        &::after {
          content: '';
          margin: 0;
        }
      }
    }

    .input-help-text {
      font-size: 13px;
      line-height: 1.6;
    }

    span.required-text {
      &::after {
        content: '(required)';
        color: ${Colors.Red4};
        font-size: 11px;
        margin: 0 6px;
      }
    }

    .editor-toolbar a {
      padding: 0 10px;
    }

    pre {
      margin: 0 0 15px;
      overflow: auto;
      line-height: 20px;
      font-family: ${fontFamilyMonospace};
      text-transform: none;
      code {
        display: block;
        padding: 10px;
        white-space: normal;
        line-height: 1.7em;
      }
    }

    /* TODO: Remove these styles applied to the right sidebar tabs when the
     * Drawer component imported from @zapier/editor-core is ugraded to
     * Zinnia 5. */
    & nav[class$='-DrawerTabs'],
    & nav[class$='-DrawerTabs'] aside {
      background-color: ${Colors.PrimeWhite} !important;
    }
    &
      nav[class$='-DrawerTabs']
      button[class$='-DrawerTabs__tabItem'][aria-label^='close the'] {
      background-color: ${Colors.UiPrimaryStronger} !important;
    }
    &
      nav[class$='-DrawerTabs']
      button[class$='-DrawerTabs__tabItem'][aria-label^='close the']:focus,
    &
      nav[class$='-DrawerTabs']
      button[class$='-DrawerTabs__tabItem'][aria-label^='close the']:hover {
      background-color: ${Colors.UiPrimaryStrongest} !important;
    }
    & nav[class$='-DrawerTabs'] + aside > div[class$='Wrapper--root'] {
      background-color: ${Colors.PrimeWhite} !important;
    }
  `,
};

export default Styles;
